// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__Dkids","address":"Footer_address__1DnoO","email":"Footer_email__lN20r","telephone":"Footer_telephone__Ldhcx"};